export const BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
  desktop: 1024
}

export const EMITTER_PROPS = {
  cart: {
    get: 'cart.get',
    add: 'cart.add',
    update: 'cart.update',
    clear: 'cart.clear',
    count: 'cart.count',
    change: 'cart.change',
    render: 'cart.render',
    openGiftModal: 'cart.open_gift_modal',
    editGift: 'cart.edit_gift'
  },
  product: {
    updateVariant: 'product.update_variant',
    openModalGallery: 'product.open_modal_gallery',
    openProductNotify: 'product.openProductNotify',
    openModalMoreInfo: 'product.openModalMoreInfo',
    resetModalMoreInfo: 'product.resetModalMoreInfo'
  },
  notice: {
    global: 'notice.global'
  },
  cache: {
    cartRender: 'cache.cart_render'
  }
}

export const RECENTLY_CONFIG = {
  cookieName: 'booie_recently_viewed', // Please change prefix every new project 'gamma_' to project name
  cookieSkusName: 'booie_recently_viewed_skus', // Please change prefix every new project 'gamma_' to project name
  expireTime: 60 * 60 * 24 * 7, // set cookie expire time to 7 days
  maxLimit: 10
}
